import { useState, useEffect, useRef, useCallback } from 'react';
import { useToast } from '../../Utils/toastContext';
import {
  setAgencyNameRedux,
  setAvailableRoleList,
} from '../../Redux/store/userSlice';
import { useSelector, useDispatch } from 'react-redux';
import Dropdown from '../../Components/CustomDropdown/customdropdown';
import AddressAutocomplete from '../../Components/addressInput/address-input';
import DropdownTest from '../../Components/CustomDropdown/ndrop';
import { useNavigate, useLocation } from 'react-router-dom';
import { debounce, set } from 'lodash';
import countriesData from '../../Data/CountryCodes.json';
import { Ban, RotateCcw, UserRoundX } from 'lucide-react';
import { formatDateTimeUTC } from '../../Constants/helper-functions';

const validator = require('validator');

const ComplianceOfficer = () => {
  const { showToast } = useToast();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const [showBlockModal, setShowBlockModal] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [reason, setReason] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, settotalPages] = useState(0);
  const [totalCount, settotalCount] = useState(0);
  const [showRecords, setShowRecords] = useState(10);
  const [filter, setFilter] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: 'desc',
  });
  const availableRoles = useSelector((state) => state.user.availableRoles);
  const isAgentRedux = availableRoles?.some(
    (r) => r.name === 'agency_compliance',
  );
  const [isAgent, setIsAgent] = useState(isAgentRedux);
  const [pendingAgentState, setPendingAgentState] = useState(null);
  const [showAgentConfirm, setShowAgentConfirm] = useState(false);
  const dispatch = useDispatch();
  const [selectAll, setSelectAll] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [redRegCountry, setRegCountry] = useState(null);
  const [registeredAddress, setRegisteredAddress] = useState('');
  const [customerFirstName, setCustomerFirstName] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');
  const [selectedCode, setSelectedCode] = useState('+61');
  const [customerLastName, setCustomerLastName] = useState('');
  const [selectedCustomers, setSelectedCustomers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [email, setEmail] = useState('');
  const [focus, setFocus] = useState(false);

  const [isOpenNewCustomer, setIsOpenNewCustomer] = useState(false);
  const addCustomerRef = useRef();
  const roleName = useSelector((state) => state.user.roleName);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [countries, setCountries] = useState([]);
  const buttonRefs = useRef({});
  const [redRegCity, setRegCity] = useState(null);
  const [redRegState, setRegState] = useState(null);
  const [filterText, setFilterText] = useState('created_at');
  const getInitials = (name) => {
    if (!name) return '?';
    return name.trim().charAt(0).toUpperCase();
  };

  const getAvatarStyle = (name) => {
    const styles = [
      'bg-[#EEF2FF] text-[#3730A3] ring-1 ring-[#E0E7FF]', // Indigo soft
      'bg-[#F1F5F9] text-[#334155] ring-1 ring-[#E2E8F0]', // Slate
      'bg-[#FDF2F8] text-[#9D174D] ring-1 ring-[#FBCFE8]', // Rose subtle
      'bg-[#F0FDF4] text-[#166534] ring-1 ring-[#BBF7D0]', // Green subtle
      'bg-[#FFFBEB] text-[#92400E] ring-1 ring-[#FDE68A]', // Amber subtle
    ];

    const index = name?.charCodeAt(0) % styles.length;
    return styles[index];
  };
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem('jwtToken');
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
          status: response.status,
        }));

        // Ensure errorData.message is extracted properly
        const errorMessage =
          typeof errorData === 'object' && errorData.message
            ? errorData.message
            : `Error ${response.status}: ${response.statusText}`;

        throw new Error(errorMessage);
      }

      return await response.json();
    } catch (error) {
      console.error('API Call Error:', error); // Log full error for debugging
      throw new Error(
        typeof error.message === 'string'
          ? error.message
          : 'Network error, please try again later',
      );
    }
  };
  const clearAllCustomerFields = () => {
    setCustomerFirstName('');
    setSelectedCode('+61');
    setMobileNumber('');
    setCustomerLastName('');
    setRegisteredAddress('');
    setEmail('');
  };
  const postInviteAPI = async () => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let payloadRegAddress = {
      address_line_1:
        registeredAddress.street == ''
          ? registeredAddress.full
          : registeredAddress.street,
      address_line_2: registeredAddress.route,
      city_id: redRegCity,
      state_id: redRegState,
      country_id: redRegCountry,
      zip_code: registeredAddress.zip,
      google_address: registeredAddress.full,
    };
    const apiUrl = `${BASE_URL}/api/v1/agency/compliance-officers/invite`;
    const bodyData = {
      first_name: customerFirstName,
      last_name: customerLastName,
      email_address: email,
      mobile_number: mobileNumber,
      country_code: selectedCode,
      address: payloadRegAddress,
    };

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));

        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const postAgentAPI = async () => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/api/v1/agency/roles/self-grant`;
    const bodyData = {
      role_id: 6, ///6 for compliance
    };

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));

        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const deleteRole = async () => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/api/v1/agency/roles/self-grant/compliance`;

    const bodyData = {};
    try {
      const response = await fetch(apiUrl, {
        method: 'DELETE',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));

        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handleMarkAgent = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = isAgent ? await deleteRole() : await postAgentAPI();
        if (response.status === 200) {
          getCustomers();
          dispatch(setAvailableRoleList(response.data.roles));
          let isag = response.data.roles?.some(
            (r) => r.name === 'agency_compliance',
          );
          console.log('isag+', isag);
          setIsAgent(isag);
          toastMessage = { message: response.message, type: 'success' };
        }
      } catch (error) {
        toastMessage = { message: error.message, type: 'error' };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000),
    [isAgent], // Dependencies
  );
  const updateApplication = async (action, officerId, reason) => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl =
      action == 'block'
        ? `${BASE_URL}/api/v1/agency/compliance-officers/${officerId}/block`
        : `${BASE_URL}/api/v1/agency/compliance-officers/${officerId}/unblock`;
    const bodyData = {
      reason: reason,
    };
    try {
      const response = await fetch(apiUrl, {
        method: 'PUT',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));

        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const getLocation = async (country, state, city) => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/api/v1/onboarding/location/ids`;

    let bodyData = {
      country: country,
      state: state,
      city: city,
    };

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handleScroll = (indexToRemove) => {
    setIsDropdownOpen(false);
  };
  const handlePendingClick = () => {
    //  setFilter("to_review");
    setIsDropdownOpen((prevState) => !prevState); // Toggle dropdown
  };
  const headers = [
    { label: 'Name', key: 'full_name' },
    { label: 'Email', key: 'email_address' },
    { label: 'Status', key: 'status' },
    { label: 'Date & Time', key: 'created_at' }, // No sorting for actions
    { label: 'Action', key: '' },
  ];
  const auditheaders = [
    { label: 'Name', key: 'full_name' },
    { label: 'Email', key: 'email_address' },
    { label: 'Status', key: 'status' },
    { label: 'Date & Time', key: 'created_at' }, // No sorting for actions
  ];
  useEffect(() => {
    setCountries(countriesData);
  }, []);
  const togglePopupAddCustomer = () => {
    clearAllCustomerFields();
    setIsOpenNewCustomer(!isOpenNewCustomer);
  };
  const handleCodeChange = (e) => {
    setSelectedCode(e.target.value);
  };
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  const toggleSelectAll = () => {
    if (selectAll) {
      setSelectedCustomers([]); // Deselect all
    } else {
      setSelectedCustomers(customers.map((customer) => customer.id)); // Select all
    }
    setSelectAll(!selectAll); // Toggle Select All state
  };
  const [preSelectedFilter, setpreSelectedFilter] = useState({
    value: 10,
    label: '10',
  });
  const filterOptions = [
    { value: 10, label: '10' },
    { value: 20, label: '20' },
    { value: 30, label: '30' },
    { value: 50, label: '50' },
  ];
  const handleAddAgency = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await postInviteAPI();
        if (response.status === 201) {
          getCustomers();
          setIsOpenNewCustomer(false);
        }
      } catch (error) {
        toastMessage = { message: error.message, type: 'error' };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000),
    [email, customerFirstName, customerLastName, selectedCode, mobileNumber], // Dependencies
  );

  const handleFilterChange = (selectedOption) => {
    console.log('Selected Option:', selectedOption);
    setpreSelectedFilter(selectedOption);
    setShowRecords(parseInt(selectedOption.value));
    setCurrentPage(1);
  };

  function formatDateTime(dateString) {
    if (!dateString) return '-';

    try {
      // remove timezone abbreviations like AEDT, AEST etc.
      const cleaned = dateString.replace(/\b[A-Z]{3,4}\b/g, '').trim();

      const parts = cleaned.split(' ');
      const [day, month, year] = parts[0].split('/');

      let [hour, min, sec] = parts[1].split(':');
      const period = parts[2];

      hour = parseInt(hour);

      // convert 12h → 24h
      if (period === 'PM' && hour !== 12) hour += 12;
      if (period === 'AM' && hour === 12) hour = 0;

      return `${day}/${month}/${year} | ${hour
        .toString()
        .padStart(2, '0')}:${min}:${sec}`;
    } catch (e) {
      return '-';
    }
  }
  const handleSort = (key) => {
    setFilterText(key);
    setSortConfig((prev) => ({
      key: key,
      direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc',
    }));
  };
  const toggleTableSelection = (customerId) => {
    setSelectedCustomers(
      (prevSelected) =>
        prevSelected.includes(customerId)
          ? prevSelected.filter((id) => id !== customerId) // Remove if already selected
          : [...prevSelected, customerId], // Add if not selected
    );
  };
  const getCustomers = async () => {
    setIsLoading(true);
    const direction = sortConfig.direction;

    try {
      let response = '';
      if (roleName == 'agency_compliance' || roleName == 'agency') {
        response = await GetAPIcalls(
          filter == ''
            ? `/api/v1/agency/compliance-officers?search=${searchQuery}&page=${currentPage}&size=${showRecords}&sort_by=${filterText}&sort_order=${direction}`
            : `/api/v1/agency/compliance-officers?search=${searchQuery}&page=${currentPage}&size=${showRecords}&status=${filter}&sort_by=${filterText}&sort_order=${direction}`,
        );
      }
      if (roleName == 'auditor') {
        response = await GetAPIcalls(
          filter == ''
            ? `/api/v1/auditor/compliance-officers?search=${searchQuery}&page=${currentPage}&size=${showRecords}&sort_by=${filterText}&sort_order=${direction}`
            : `/api/v1/auditor/compliance-officers?search=${searchQuery}&page=${currentPage}&size=${showRecords}&status=${filter}&sort_by=${filterText}&sort_order=${direction}`,
        );
      }
      if (response.status == 200) {
        setCustomers(response.data.compliance_officers);
        settotalPages(response.data.total_pages);
        setCurrentPage(response.data.page);
        settotalCount(response.data.total);
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
      }
    } catch (err) {
      showToast(err.message, 'error');
    } finally {
      setTimeout(function () {
        setIsLoading(false);
        setSortConfig({ key: null, direction });
      }, 100);
    }
  };
  const handleUpdateApplication = useCallback(
    debounce(async (e, action, officerId, reason = null) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await updateApplication(action, officerId, reason);
        if (response.status == 200) {
          toastMessage = {
            message: response.message,
            type: 'success',
          };
          getCustomers();
        } else {
          toastMessage = { message: response.message, type: 'error' };
        }
      } catch (error) {
        toastMessage = { message: error.message, type: 'error' };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 1000); // Small delay if needed
        }
      }
    }, 1000),
    [reason], // Dependencies
  );
  const getAllLocationDetailsReg = async () => {
    try {
      const response = await getLocation(
        registeredAddress.country &&
          registeredAddress.country.name &&
          registeredAddress.country.name !== ''
          ? registeredAddress.country.name
          : registeredAddress.country,
        registeredAddress.state &&
          registeredAddress.state.name &&
          registeredAddress.state.name !== ''
          ? registeredAddress.state.name
          : registeredAddress.state,
        registeredAddress.city &&
          registeredAddress.city.name &&
          registeredAddress.city.name !== ''
          ? registeredAddress.city.name
          : registeredAddress.city,
      );
      setRegCountry(response.country_id);
      setRegState(response.state_id);
      setRegCity(response.city_id);
    } catch (err) {
      setRegCountry(null);
      setRegState(null);
      setRegCity(null);
      showToast(err.message, 'error');
    }
  };
  useEffect(() => {
    getCustomers();
  }, [
    searchQuery,
    currentPage,
    showRecords,
    filter,
    filterText,
    sortConfig.direction,
  ]);
  useEffect(() => {
    if (
      (registeredAddress && registeredAddress.country) ||
      (registeredAddress && registeredAddress.country.name)
    ) {
      getAllLocationDetailsReg();
    }
  }, [registeredAddress]);
  return (
    <div className="pt-4 p-2 lg:min-w-[78vw] lg:max-w-[80vw]">
      {loading && (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
          <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}
      <div
        onScroll={handleScroll}
        className="pt-4  text-xs overflow-x-auto  flex-wrap items-center"
      >
        <div className="flex mb-2 ">
          <button
            onClick={() => setFilter('')}
            className={`px-4 py-2 lg:w-20 rounded-l-xl border-r border-gray-100 ${
              filter === '' ? 'bg-[#375AE7] text-white' : 'bg-white text-black'
            }`}
          >
            All
          </button>
          <button
            onClick={() => setFilter('active')}
            className={`lg:px-4 px-2 py-2 border-r border-gray-100 ${
              filter === 'active'
                ? 'bg-[#375AE7] text-white'
                : 'bg-white text-black'
            }`}
          >
            Active
          </button>
          <button
            onClick={() => setFilter('onboarding')}
            className={`px-4 py-2  ${
              filter === 'onboarding'
                ? 'bg-[#375AE7] text-white'
                : 'bg-white text-black'
            }`}
          >
            Onboarding
          </button>
          <button
            onClick={() => setFilter('pending')}
            className={`px-4 py-2  ${
              filter === 'pending'
                ? 'bg-[#375AE7] text-white'
                : 'bg-white text-black'
            }`}
          >
            Pending
          </button>
          <button
            onClick={() => setFilter('to_review')}
            className={`px-4 py-2  ${
              filter === 'to_review'
                ? 'bg-[#375AE7] text-white'
                : 'bg-white text-black'
            }`}
          >
            To Review
          </button>
          <button
            onClick={() => setFilter('sent_for_resubmit')}
            className={`px-4 py-2  ${
              filter === 'sent_for_resubmit'
                ? 'bg-[#375AE7] text-white'
                : 'bg-white text-black'
            }`}
          >
            Sent for Resubmit
          </button>
          <button
            onClick={() => setFilter('blocked')}
            className={`px-4 py-2 rounded-r-xl ${
              filter === 'blocked'
                ? 'bg-[#375AE7] text-white'
                : 'bg-white text-black'
            }`}
          >
            Blocked
          </button>
        </div>
      </div>
      {roleName == 'agency' && (
        <div className="w-full  p-4 bg-white rounded-lg shadow-lg  relative">
          <div className="flex justify-between items-center mb-4 border-b pb-5 border-gray-100">
            <div className="flex items-center">
              <img
                src="/customer-black.svg"
                alt="Company Logo"
                className="mr-3"
              />
              <span className="font-medium lg:text-xl text-sm">
                Compliance Officer List
              </span>
            </div>
            {roleName == 'agency' && (
              <>
                <div className="relative inline-block flex flex-row gap-4">
                  {/* TOGGLE - MARK/REMOVE ME AS AGENT */}

                  {!isAgent && (
                    <div
                      ref={addCustomerRef}
                      className="flex items-center space-x-4"
                    >
                      <div className="relative inline-block ">
                        <div
                          className="flex items-center justify-center gap-2 px-4 py-2 border border-[#375AE7] text-[#375AE7] rounded-xl cursor-pointer h-11 w-auto"
                          onClick={() => togglePopupAddCustomer()}
                        >
                          <img
                            src="/Plus.svg"
                            alt="document-download"
                            className="mr-2"
                          />
                          <span>Invite Compliance Officer</span>
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="flex items-center gap-2">
                    <span className="text-sm text-gray-600">
                      {isAgent
                        ? 'You are a compliance officer'
                        : 'Mark Me as Compliance Officer'}{' '}
                    </span>

                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        setLoading(true);
                        handleMarkAgent(e);
                      }}
                      className={`
            relative inline-flex h-6 w-11 items-center rounded-full transition
            ${isAgent ? 'bg-[#375AE7]' : 'bg-gray-300'}
          `}
                    >
                      <span
                        className={`
              inline-block h-4 w-4 transform rounded-full bg-white transition
              ${isAgent ? 'translate-x-6' : 'translate-x-1'}
            `}
                      />
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
          {isOpenNewCustomer && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
              <div className="bg-white rounded-lg w-[90%] md:w-[900px] p-6 mt-4 h-[60vh] max-h-screen overflow-y-auto">
                {/* Modal Header */}
                <div>
                  <div className="flex items-center justify-between mb-4">
                    <h2 className="text-lg font-medium text-center w-full">
                      Invite Compliance Officer
                    </h2>
                    <div className="flex justify-end">
                      <img
                        onClick={togglePopupAddCustomer}
                        src="/add.svg"
                        alt="Add"
                        className="w-10 h-10 cursor-pointer"
                      />
                    </div>
                  </div>
                  <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                    {/* Left Column */}
                    <div className="space-y-4 pt-4 px-4">
                      <div>
                        <label
                          htmlFor="finInstituition"
                          className="mb-1 text-sm text-labelColour"
                        >
                          First Name
                        </label>{' '}
                        <input
                          id="finInstituition"
                          type="text"
                          value={customerFirstName}
                          onChange={(e) => setCustomerFirstName(e.target.value)}
                          className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                          placeholder="John Daniel"
                        />
                      </div>
                      <div>
                        <label
                          htmlFor="finInstituition"
                          className="mb-1 mt-4 text-sm text-labelColour"
                        >
                          Mobile Number
                        </label>{' '}
                        <div className="flex  items-center">
                          <select
                            value={selectedCode}
                            onChange={handleCodeChange}
                            onFocus={() => setFocus(true)}
                            onBlur={() => setFocus(false)}
                            className={`w-40  appearance-none border text-black  appearance-none text-sm font-medium rounded-tl-md rounded-tr-none rounded-br-none rounded-bl-md h-[2.813rem]  ${
                              focus
                                ? 'border-black border-2'
                                : ' border-gray-300 '
                            } border-r-0   border  py-2 px-1 leading-tight focus:outline-none `}
                            placeholder="AU+61"
                          >
                            {countries.map((country) => (
                              <option
                                key={country.code}
                                value={country.dialCode}
                              >
                                {country.code} {country.dialCode}
                              </option>
                            ))}
                          </select>
                          <input
                            type="tel"
                            id="mobileNumber"
                            value={mobileNumber}
                            onFocus={() => setFocus(true)}
                            onBlur={() => setFocus(false)}
                            onChange={(e) => setMobileNumber(e.target.value)}
                            placeholder="Mobile Number"
                            className={`border text-black text-base font-medium rounded-tr-md rounded-tl-none rounded-bl-none rounded-br-md h-[2.813rem] p-2 ${
                              focus
                                ? 'border-black border-2'
                                : ' border-gray-300 '
                            } rounded-md focus:outline-none w-full border-l-0 appearance-none`}
                          />
                        </div>
                      </div>
                    </div>

                    {/* Center Column with Border */}
                    <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                      <div>
                        <label
                          htmlFor="finInstituition"
                          className="mb-1 text-sm text-labelColour"
                        >
                          Last Name
                        </label>{' '}
                        <input
                          id="finInstituition"
                          type="text"
                          value={customerLastName}
                          onChange={(e) => setCustomerLastName(e.target.value)}
                          className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                          placeholder="John Daniel"
                        />
                      </div>
                      <div className="mt-4">
                        <label
                          htmlFor="finInstituition"
                          className="mb-1 text-sm text-labelColour"
                        >
                          Email
                        </label>{' '}
                        <input
                          id="finInstituition"
                          type="text"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                          placeholder="John Daniel"
                        />
                      </div>
                    </div>

                    {/* Right Column */}
                    <div className="space-y-4 px-4 pt-4">
                      <div>
                        <label
                          htmlFor="finInstituition"
                          className="mb-1 text-sm text-labelColour"
                        >
                          Address
                        </label>{' '}
                        <AddressAutocomplete
                          value={registeredAddress?.full}
                          className="w-full"
                          onSelect={(addr) => {
                            setRegisteredAddress(addr);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-center space-x-4 mt-6 md:mt-20">
                    <button
                      onClick={togglePopupAddCustomer}
                      className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        if (!validateEmail(email)) {
                          showToast('Please enter a valid email', 'error');
                          return;
                        }
                        if (!customerLastName) {
                          showToast('Please enter last name', 'error');
                          return;
                        }
                        if (
                          !validator.isMobilePhone(
                            selectedCode + mobileNumber,
                            'any',
                          )
                        ) {
                          showToast(
                            'Please enter valid mobile number',
                            'error',
                          );
                          return;
                        }
                        if (!customerFirstName) {
                          showToast('Please enter first name', 'error');
                          return;
                        }
                        if (!registeredAddress || !redRegCountry) {
                          showToast('Please enter valid address', 'error');
                          return;
                        }

                        setLoading(true);
                        handleAddAgency(e);
                      }}
                      className="px-6 py-2 rounded-lg bg-[#375AE7] text-white"
                    >
                      Send Now
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="flex justify-between flex-col lg:flex-row flex-wrap mb-4 gap-4 mb-4">
            <div className="flex items-left flex-col lg:flex-row flex-wrap  gap-4 lg:space-x-4 lg:space-y-0 space-x-0">
              <div className="flex items-center space-x-2">
                <span className="lg:text-md  text-sm text-[#8C8C8C]">
                  Show Records
                </span>
                <Dropdown
                  label=""
                  options={filterOptions}
                  preselectedValue={preSelectedFilter}
                  onSelect={handleFilterChange}
                />
              </div>
              <div className="flex items-center">
                <div className="relative">
                  <input
                    type="text"
                    className="p-2 pl-6 w-full sm:w-80 md:w-96 lg:w-[420px] text-sm border rounded-xl"
                    placeholder="Search Compliance Officer"
                    value={searchQuery}
                    onChange={(e) => {
                      setCurrentPage(1);
                      setSearchQuery(e.target.value);
                    }}
                  />
                  <span className="absolute left-2 top-3 text-gray-500">
                    {' '}
                    <img
                      src="/search-normal.svg"
                      alt="Company Logo"
                      className="mr-2"
                    />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div>
            {/* Table */}
            <div className="overflow-x-auto">
              <table className="w-full h-full table-auto w-full border-separate border-spacing-y-4 border-spacing-x-0">
                {/* Table Header */}
                <thead className="text-[#8C8C8C] bg-[#F9F9F9] text-sm">
                  <tr className="mb-4">
                    {/* Dynamic Headers */}
                    {headers.map((header, index) => (
                      <th
                        onClick={() => handleSort(header.key)}
                        key={header.label}
                        className={`
          cursor-pointer font-medium px-4 py-4 border text-left
          ${index === 0 ? 'rounded-l-xl' : ''}
          ${index === headers.length - 1 ? 'rounded-r-xl' : ''}
        `}
                      >
                        <div className="flex items-center justify-between w-full">
                          <span>{header.label}</span>

                          {header.key !== '' && (
                            <img
                              src="/sort.svg"
                              alt="Sort Icon"
                              className="w-4 h-4 ml-auto"
                            />
                          )}
                        </div>
                      </th>
                    ))}
                  </tr>
                </thead>

                {isLoading ? (
                  <tbody className="shimmer-container-list ">
                    {/* Creating 5 rows of shimmer effect */}
                    {[...Array(5)].map((_, rowIndex) => (
                      <tr key={rowIndex} className="shimmer-row-list">
                        {/* Creating 7 cells in each row for shimmer */}
                        {[...Array(10)].map((_, colIndex) => (
                          <td key={colIndex} className="shimmer-cell-list">
                            <div className="shimmer-loader"></div>
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                ) : (
                  <tbody className="text-sm mt-4 font-medium text-black">
                    {customers.length > 0 ? (
                      <>
                        {customers.map((customer) => (
                          <tr key={customer.id} className="px-6 py-2 bg-white">
                            <td
                              onClick={() => {
                                if (
                                  filter == 'active' ||
                                  customer.status.label == 'suspended' ||
                                  customer.status.label == 'archived' ||
                                  customer.status.label == 'active' ||
                                  filter == 'suspended' ||
                                  filter == 'archived'
                                ) {
                                  dispatch(
                                    setAgencyNameRedux(customer.full_name),
                                  );
                                  let redirectState = {
                                    path: `/compliance-details/${customer.user_id}`,
                                    state: {
                                      from: location.pathname,
                                      historyStack: [
                                        ...(location.state?.historyStack || []),
                                        location.pathname,
                                      ],
                                    },
                                  };
                                  sessionStorage.setItem(
                                    'redirectAfterLogin',
                                    JSON.stringify(redirectState),
                                  );
                                  navigate(
                                    `/compliance-details/${customer.user_id}`,
                                    {
                                      state: {
                                        from: location.pathname,
                                        historyStack: [
                                          ...(location.state?.historyStack ||
                                            []),
                                          location.pathname,
                                        ],
                                      },
                                    },
                                  );
                                }
                              }}
                              disabled={
                                !(
                                  filter == 'active' ||
                                  customer.status.label == 'active' ||
                                  customer.status.label == 'suspended' ||
                                  customer.status.label == 'archived' ||
                                  filter == 'suspended' ||
                                  filter == 'archived'
                                )
                              }
                              className={`${
                                filter == 'active' ||
                                customer.status.label == 'suspended' ||
                                customer.status.label == 'archived' ||
                                customer.status.label == 'active' ||
                                filter == 'suspended' ||
                                filter == 'archived'
                                  ? 'cursor-pointer'
                                  : ''
                              } px-4 py-6 border-b border-t border-l border-r-0 rounded-l-xl text-left min-w-[200px] max-w-[auto] font-medium flex items-center space-x-2`}
                            >
                              <div
                                className={`w-10 h-10 flex items-center justify-center rounded-full font-semibold text-sm ${getAvatarStyle(
                                  customer.full_name,
                                )}`}
                              >
                                {getInitials(customer.full_name)}
                              </div>
                              <span
                                className={`${
                                  customer.status.label != 'onboarding' &&
                                  customer.status.label != 'pending'
                                    ? 'underline cursor-pointer'
                                    : ''
                                } text-left`}
                              >
                                {customer.full_name}
                              </span>
                            </td>
                            <td className="px-4 py-2 w-40 border-b border-t relative">
                              {customer.email_address}
                            </td>
                            <td className="px-4 w-20 border-b border-t text-center py-2">
                              <button
                                className={` w-40 text-center  font-medium h-10 rounded-xl text-xs px-2 py-2  flex justify-center items-center focus:outline-none${
                                  customer.status.label == 'active'
                                    ? ' text-[#34C046] bg-[#34C046] bg-opacity-20'
                                    : ''
                                }
                              ${
                                customer.status.label == 'onboarding'
                                  ? ' text-[#375AE7] bg-[#375AE7] bg-opacity-20'
                                  : ''
                              }
                                 ${
                                   customer.status.label == 'draft'
                                     ? ' text-[#375AE7] bg-[#375AE7] bg-opacity-20'
                                     : ''
                                 }
                            ${
                              customer.status.label == 'to_review'
                                ? ' text-[#F77E27] bg-[#F77E27] bg-opacity-20'
                                : ''
                            }
                                ${
                                  customer.status.label == 'in_progress'
                                    ? ' text-[#FFC421] bg-[#FFC421] bg-opacity-20'
                                    : ''
                                }
                                 ${
                                   customer.status.label == 'pending'
                                     ? ' text-[#FFC421] bg-[#FFC421] bg-opacity-20'
                                     : ''
                                 }
                                ${
                                  customer.status.label == 'resubmit'
                                    ? ' text-[#3047EC] bg-[#3047EC] bg-opacity-20'
                                    : ''
                                }
                                ${
                                  customer.status.label == 'sent_for_resubmit'
                                    ? ' text-[#3047EC] bg-[#3047EC] bg-opacity-20'
                                    : ''
                                }
                                ${
                                  customer.status.label == 'sent_for_approval'
                                    ? ' text-[#3047EC] bg-[#3047EC] bg-opacity-20'
                                    : ''
                                }
                                  ${
                                    customer.status.label == 'rejected'
                                      ? ' text-[#FF5050] bg-[#FF5050] bg-opacity-20'
                                      : ''
                                  }
                                    ${
                                      customer.status.label == 'blocked'
                                        ? ' text-[#FF5050] bg-[#FF5050] bg-opacity-20'
                                        : ''
                                    }
                                   ${
                                     customer.status.label == 'deleted'
                                       ? ' text-[#FF5050] bg-[#FF5050] bg-opacity-20'
                                       : ''
                                   }
                               ${
                                 customer.status.label == 'suspended'
                                   ? ' text-white bg-[#FF5050]'
                                   : ''
                               }
                               ${
                                 customer.status.label == 'closed'
                                   ? ' text-[#000000] bg-[#000000] bg-opacity-20'
                                   : ''
                               }
                                ${
                                  customer.status.label == 'archived'
                                    ? ' text-[#A6A6A6] bg-[#A6A6A6] bg-opacity-20'
                                    : ''
                                }
                              `}
                              >
                                <span className="mr-6 text-center">
                                  {customer.status.label
                                    .replace(/_/g, ' ')
                                    .replace(/\b\w/g, (char) =>
                                      char.toUpperCase(),
                                    )}
                                </span>
                              </button>
                            </td>
                            <td className="px-4 py-2 border-b border-t rounded-r  border-r-0  border-l-0 text-ellipsis border overflow-hidden whitespace-nowrap">
                              <div className="flex items-center px-2 space-x-2">
                                <img
                                  src="/clock.svg"
                                  alt="Time Icon"
                                  className="h-4 w-4"
                                />
                                <span className="rounded-xl">
                                  {formatDateTimeUTC(customer.created_at)}
                                </span>
                              </div>
                            </td>
                            <td className="px-4 py-3 border-b border-t border-l-0 rounded-r-xl border rounded-r">
                              <div className="flex items-center gap-2">
                                {/* BLOCK */}
                                {customer.status?.label !== 'blocked' && (
                                  <button
                                    onClick={() => {
                                      setSelectedUserId(customer.user_id);
                                      setReason('');
                                      setError('');
                                      setShowBlockModal(true);
                                    }}
                                    className="
  group inline-flex items-center gap-1.5 rounded-full
  border border-slate-200 bg-white px-3.5 py-1.5
  text-xs sm:text-sm font-medium text-slate-700
  shadow-sm transition-all duration-200
  hover:border-[#375AE7] hover:text-[#375AE7]
  hover:bg-[#375AE7]/5 hover:shadow-md active:scale-95
  "
                                  >
                                    <Ban size={14} />
                                    Block
                                  </button>
                                )}

                                {/* UNBLOCK */}
                                {customer.status?.label === 'blocked' && (
                                  <button
                                    onClick={(e) => {
                                      setLoading(true);
                                      handleUpdateApplication(
                                        e,
                                        'unblock',
                                        customer.user_id,
                                      );
                                    }}
                                    className="
        group
        inline-flex
        items-center
        gap-1.5
        rounded-full
        border
        border-slate-200
        bg-white
        px-3.5
        py-1.5
        text-xs
        sm:text-sm
        font-medium
        text-slate-700
        shadow-sm
        transition-all
        duration-200
        hover:border-[#375AE7]
        hover:text-[#375AE7]
        hover:bg-[#375AE7]/5
        hover:shadow-md
        active:scale-95
        "
                                  >
                                    <RotateCcw
                                      size={14}
                                      className="transition-transform group-hover:scale-110"
                                    />
                                    Unblock
                                  </button>
                                )}
                              </div>
                            </td>
                          </tr>
                        ))}
                      </>
                    ) : (
                      <tr>
                        <td colSpan="5">
                          <div className="flex flex-col items-center justify-center py-20 px-6 bg-white rounded-2xl text-center">
                            {/* ICON */}
                            <div className="w-16 h-16 flex items-center justify-center rounded-full bg-blue-50 mb-5">
                              <UserRoundX
                                className="w-7 h-7 text-[#375AE7]"
                                strokeWidth={1.8}
                              />
                            </div>

                            {/* TITLE */}
                            <h3 className="text-base font-semibold text-gray-800">
                              No compliance officers available
                            </h3>

                            {/* DESCRIPTION */}
                            <p className="text-sm font-normal text-gray-500 mt-2 max-w-md">
                              {searchQuery
                                ? `No compliance officers found for "${searchQuery}".`
                                : 'No compliance officers found. Invite a new compliance officer to get started.'}
                            </p>

                            {/* ACTION BUTTON */}
                            <button
                              onClick={() => {
                                // navigate or open add member modal
                                togglePopupAddCustomer();
                              }}
                              className="
            mt-6
            inline-flex items-center gap-2
            px-5 py-2.5
            rounded-xl
            bg-[#375AE7]
            text-white
            text-sm
            font-medium
            shadow-sm
            hover:shadow-md
            hover:bg-[#2f4fd0]
            transition-all
            duration-200
            active:scale-95
          "
                            >
                              <svg
                                className="w-5 h-5"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  d="M12 4v16m8-8H4"
                                />
                              </svg>
                              Invite Compliance Officer
                            </button>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                )}
              </table>
            </div>

            {customers?.length > 0 && (
              <div className="flex flex-wrap justify-between items-center mt-4 space-y-4 sm:space-y-0">
                {/* Entries Info Section */}
                <div className="text-[#8C8C8C] text-sm sm:text-base w-full sm:w-auto text-center sm:text-left">
                  Showing {showRecords * (currentPage - 1) + 1} to{' '}
                  {currentPage === totalPages || totalPages == 0
                    ? totalCount
                    : Math.max(
                        showRecords * currentPage,
                        customers.length,
                      )}{' '}
                  of {totalCount} entries
                </div>

                {/* Pagination Section */}
                <div className="flex flex-wrap items-center justify-center sm:justify-end font-semibold text-sm gap-2 w-full sm:w-auto">
                  {/* Previous Button */}
                  <button
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage((prev) => prev - 1)}
                    className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Prev
                  </button>

                  {/* Page Buttons */}
                  {Array.from({ length: Math.min(totalPages, 5) }).map(
                    (_, index) => {
                      const startPage = Math.max(
                        1,
                        Math.min(totalPages - 4, currentPage - 2),
                      );
                      const page = startPage + index;

                      return (
                        <button
                          key={page}
                          onClick={() => setCurrentPage(page)}
                          className={`px-3 py-1 rounded ${
                            currentPage === page
                              ? 'bg-[#375AE7] text-white'
                              : 'bg-white border border-gray-300 text-black'
                          }`}
                        >
                          {page}
                        </button>
                      );
                    },
                  )}

                  {/* Next Button */}
                  <button
                    disabled={currentPage === totalPages}
                    onClick={() => setCurrentPage((prev) => prev + 1)}
                    className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Next
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
      {roleName == 'auditor' && (
        <div className="w-full  p-4 bg-white rounded-lg shadow-lg  relative">
          <div className="flex justify-between items-center mb-4 border-b pb-5 border-gray-100">
            <div className="flex items-center">
              <img
                src="/customer-black.svg"
                alt="Company Logo"
                className="mr-3"
              />
              <span className="font-medium lg:text-xl text-sm">
                Compliance Officer List
              </span>
            </div>
          </div>
          <div className="flex justify-between flex-col lg:flex-row flex-wrap mb-4 gap-4 mb-4">
            <div className="flex items-left flex-col lg:flex-row flex-wrap  gap-4 lg:space-x-4 lg:space-y-0 space-x-0">
              <div className="flex items-center space-x-2">
                <span className="lg:text-md  text-sm text-[#8C8C8C]">
                  Show Records
                </span>
                <Dropdown
                  label=""
                  options={filterOptions}
                  preselectedValue={preSelectedFilter}
                  onSelect={handleFilterChange}
                />
              </div>
              <div className="flex items-center">
                <div className="relative">
                  <input
                    type="text"
                    className="p-2 pl-6 w-full sm:w-80 md:w-96 lg:w-[420px] text-sm border rounded-xl"
                    placeholder="Search Compliance Officer"
                    value={searchQuery}
                    onChange={(e) => {
                      setCurrentPage(1);
                      setSearchQuery(e.target.value);
                    }}
                  />
                  <span className="absolute left-2 top-3 text-gray-500">
                    {' '}
                    <img
                      src="/search-normal.svg"
                      alt="Company Logo"
                      className="mr-2"
                    />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div>
            {/* Table */}
            <div className="overflow-x-auto">
              <table className="w-full h-full table-auto w-full border-separate border-spacing-y-4 border-spacing-x-0">
                {/* Table Header */}
                <thead className="text-[#8C8C8C] bg-[#F9F9F9] text-sm">
                  <tr className="mb-4">
                    {/* Dynamic Headers */}
                    {auditheaders.map((header, index) => (
                      <th
                        onClick={() => handleSort(header.key)}
                        key={header.label}
                        className={`
          cursor-pointer font-medium px-4 py-4 border text-left
          ${index === 0 ? 'rounded-l-xl' : ''}
          ${index === auditheaders.length - 1 ? 'rounded-r-xl' : ''}
        `}
                      >
                        <div className="flex items-center justify-between w-full">
                          <span>{header.label}</span>

                          {header.key !== '' && (
                            <img
                              src="/sort.svg"
                              alt="Sort Icon"
                              className="w-4 h-4 ml-auto"
                            />
                          )}
                        </div>
                      </th>
                    ))}
                  </tr>
                </thead>

                {isLoading ? (
                  <tbody className="shimmer-container-list ">
                    {/* Creating 5 rows of shimmer effect */}
                    {[...Array(5)].map((_, rowIndex) => (
                      <tr key={rowIndex} className="shimmer-row-list">
                        {/* Creating 7 cells in each row for shimmer */}
                        {[...Array(10)].map((_, colIndex) => (
                          <td key={colIndex} className="shimmer-cell-list">
                            <div className="shimmer-loader"></div>
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                ) : (
                  <tbody className="text-sm mt-4 font-medium text-black">
                    {customers.length > 0 ? (
                      <>
                        {customers.map((customer) => (
                          <tr key={customer.id} className="px-6 py-2 bg-white">
                            <td
                              className={`px-4 py-6 border-b border-t border-l border-r-0 rounded-l-xl text-left min-w-[200px] max-w-[auto] font-medium flex items-center space-x-2`}
                            >
                              <div
                                className={`w-10 h-10 flex items-center justify-center rounded-full font-semibold text-sm ${getAvatarStyle(
                                  customer.full_name,
                                )}`}
                              >
                                {getInitials(customer.full_name)}
                              </div>
                              <span className={`text-left`}>
                                {customer.full_name}
                              </span>
                            </td>
                            <td className="px-4 py-2 w-40 border-b border-t relative">
                              {customer.email_address}
                            </td>
                            <td className="px-4 w-20 border-b border-t text-center py-2">
                              <button
                                className={` w-40 text-center  font-medium h-10 rounded-xl text-xs px-2 py-2  flex justify-center items-center focus:outline-none${
                                  customer.status.label == 'active'
                                    ? ' text-[#34C046] bg-[#34C046] bg-opacity-20'
                                    : ''
                                }
                              ${
                                customer.status.label == 'onboarding'
                                  ? ' text-[#375AE7] bg-[#375AE7] bg-opacity-20'
                                  : ''
                              }
                                 ${
                                   customer.status.label == 'draft'
                                     ? ' text-[#375AE7] bg-[#375AE7] bg-opacity-20'
                                     : ''
                                 }
                            ${
                              customer.status.label == 'to_review'
                                ? ' text-[#F77E27] bg-[#F77E27] bg-opacity-20'
                                : ''
                            }
                                ${
                                  customer.status.label == 'in_progress'
                                    ? ' text-[#FFC421] bg-[#FFC421] bg-opacity-20'
                                    : ''
                                }
                                 ${
                                   customer.status.label == 'pending'
                                     ? ' text-[#FFC421] bg-[#FFC421] bg-opacity-20'
                                     : ''
                                 }
                                ${
                                  customer.status.label == 'resubmit'
                                    ? ' text-[#3047EC] bg-[#3047EC] bg-opacity-20'
                                    : ''
                                }
                                ${
                                  customer.status.label == 'sent_for_resubmit'
                                    ? ' text-[#3047EC] bg-[#3047EC] bg-opacity-20'
                                    : ''
                                }
                                ${
                                  customer.status.label == 'sent_for_approval'
                                    ? ' text-[#3047EC] bg-[#3047EC] bg-opacity-20'
                                    : ''
                                }
                                  ${
                                    customer.status.label == 'rejected'
                                      ? ' text-[#FF5050] bg-[#FF5050] bg-opacity-20'
                                      : ''
                                  }
                                    ${
                                      customer.status.label == 'blocked'
                                        ? ' text-[#FF5050] bg-[#FF5050] bg-opacity-20'
                                        : ''
                                    }
                                   ${
                                     customer.status.label == 'deleted'
                                       ? ' text-[#FF5050] bg-[#FF5050] bg-opacity-20'
                                       : ''
                                   }
                               ${
                                 customer.status.label == 'suspended'
                                   ? ' text-white bg-[#FF5050]'
                                   : ''
                               }
                               ${
                                 customer.status.label == 'closed'
                                   ? ' text-[#000000] bg-[#000000] bg-opacity-20'
                                   : ''
                               }
                                ${
                                  customer.status.label == 'archived'
                                    ? ' text-[#A6A6A6] bg-[#A6A6A6] bg-opacity-20'
                                    : ''
                                }
                              `}
                              >
                                <span className="mr-6 text-center">
                                  {customer.status.label
                                    .replace(/_/g, ' ')
                                    .replace(/\b\w/g, (char) =>
                                      char.toUpperCase(),
                                    )}
                                </span>
                              </button>
                            </td>
                            <td className="px-4 py-2 border-b border-t rounded-r-2xl  border-r border-l-0 text-ellipsis border overflow-hidden whitespace-nowrap">
                              <div className="flex items-center px-2 space-x-2">
                                <img
                                  src="/clock.svg"
                                  alt="Time Icon"
                                  className="h-4 w-4"
                                />
                                <span className="rounded-xl">
                                  {formatDateTimeUTC(customer.created_at)}
                                </span>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </>
                    ) : (
                      <tr>
                        <td colSpan="5">
                          <div className="flex flex-col items-center justify-center py-20 px-6 bg-white rounded-2xl text-center">
                            {/* ICON */}
                            <div className="w-16 h-16 flex items-center justify-center rounded-full bg-blue-50 mb-5">
                              <UserRoundX
                                className="w-7 h-7 text-[#375AE7]"
                                strokeWidth={1.8}
                              />
                            </div>

                            {/* TITLE */}
                            <h3 className="text-base font-semibold text-gray-800">
                              No compliance officers available
                            </h3>

                            {/* DESCRIPTION */}
                            <p className="text-sm font-normal text-gray-500 mt-2 max-w-md">
                              {searchQuery
                                ? `No compliance officers found for "${searchQuery}".`
                                : 'There are currently no compliance officers available. Any new additions will appear here.'}
                            </p>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                )}
              </table>
            </div>

            {customers?.length > 0 && (
              <div className="flex flex-wrap justify-between items-center mt-4 space-y-4 sm:space-y-0">
                {/* Entries Info Section */}
                <div className="text-[#8C8C8C] text-sm sm:text-base w-full sm:w-auto text-center sm:text-left">
                  Showing {showRecords * (currentPage - 1) + 1} to{' '}
                  {currentPage === totalPages || totalPages == 0
                    ? totalCount
                    : Math.max(
                        showRecords * currentPage,
                        customers.length,
                      )}{' '}
                  of {totalCount} entries
                </div>

                {/* Pagination Section */}
                <div className="flex flex-wrap items-center justify-center sm:justify-end font-semibold text-sm gap-2 w-full sm:w-auto">
                  {/* Previous Button */}
                  <button
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage((prev) => prev - 1)}
                    className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Prev
                  </button>

                  {/* Page Buttons */}
                  {Array.from({ length: Math.min(totalPages, 5) }).map(
                    (_, index) => {
                      const startPage = Math.max(
                        1,
                        Math.min(totalPages - 4, currentPage - 2),
                      );
                      const page = startPage + index;

                      return (
                        <button
                          key={page}
                          onClick={() => setCurrentPage(page)}
                          className={`px-3 py-1 rounded ${
                            currentPage === page
                              ? 'bg-[#375AE7] text-white'
                              : 'bg-white border border-gray-300 text-black'
                          }`}
                        >
                          {page}
                        </button>
                      );
                    },
                  )}

                  {/* Next Button */}
                  <button
                    disabled={currentPage === totalPages}
                    onClick={() => setCurrentPage((prev) => prev + 1)}
                    className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Next
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
      {showBlockModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
          <div
            className="
      w-full max-w-md rounded-2xl bg-white p-6
      shadow-[0_20px_60px_-15px_rgba(0,0,0,0.25)]
      animate-in fade-in zoom-in-95
    "
          >
            {/* Header */}
            <h2 className="text-lg font-semibold text-slate-900">
              Confirm Block
            </h2>

            <p className="mt-1 text-sm text-slate-500">
              Please provide a reason for blocking this user.
            </p>

            {/* Textarea */}
            <textarea
              value={reason}
              maxLength={200}
              minLength={10}
              onChange={(e) => {
                setReason(e.target.value);
                if (e.target.value.length >= 10) setError('');
              }}
              placeholder="Enter reason (minimum 10 characters)..."
              className="
        mt-4 w-full rounded-xl border border-slate-200
        p-3 text-sm outline-none transition
        focus:border-[#375AE7] focus:ring-2 focus:ring-[#375AE7]/20
        "
              rows={4}
            />

            {/* Error */}
            {error && <p className="mt-2 text-xs text-red-500">{error}</p>}

            {/* Footer */}
            <div className="mt-5 flex justify-end gap-3">
              <button
                onClick={() => setShowBlockModal(false)}
                className="
          rounded-full border border-slate-200 px-4 py-2
          text-sm text-slate-600 hover:bg-slate-100
          "
              >
                Cancel
              </button>

              <button
                onClick={(e) => {
                  if (reason.trim().length < 10) {
                    setError('Reason must be at least 10 characters.');
                    return;
                  }

                  setLoading(true);
                  handleUpdateApplication(
                    e,
                    'block',
                    selectedUserId,
                    reason, // ✅ pass reason
                  );

                  setShowBlockModal(false);
                }}
                disabled={reason.trim().length < 10}
                className={`
          rounded-full px-4 py-2 text-sm font-medium text-white
          transition-all
          ${
            reason.trim().length >= 10
              ? 'bg-[#375AE7] hover:bg-[#2f4fd1]'
              : 'bg-slate-300 cursor-not-allowed'
          }
          `}
              >
                Confirm Block
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ComplianceOfficer;
